import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import calendar from 'dayjs/plugin/calendar';
import dayjs from 'dayjs';
import { LockFilled } from '@ant-design/icons';
import React from 'react';
import { Tag } from 'antd';
import utc from 'dayjs/plugin/utc';
dayjs.extend(calendar);
dayjs.extend(utc);
export const CustomerViewTitle = (props) => {
    const { id, customer } = props;
    return customer ?
        React.createElement("div", null,
            React.createElement("div", { className: 'customer-view-title', id: id },
                React.createElement("span", { className: 'h1' }, customer.name),
                React.createElement("span", { className: 'customer-view-title-tag' }, customer.isLocked &&
                    React.createElement(Tag, { color: 'gold', icon: React.createElement(LockFilled, null) }, ADMIN_DASHBOARD_COPY.LOCKED))),
            React.createElement("div", { className: 'text-14' }, ADMIN_DASHBOARD_COPY.ENROLLED_ON(dayjs.utc(customer === null || customer === void 0 ? void 0 : customer.enrolled).local()
                .calendar()))) : null;
};
